document.addEventListener("DOMContentLoaded", function () {

  const sliders = document.querySelectorAll(".cs-collection");

  sliders.forEach(slider => {

    const track = slider.querySelector(".cs-collection__track");
    const nextBtn = slider.querySelector(".cs-collection__btn--next");
    const prevBtn = slider.querySelector(".cs-collection__btn--prev");

    const scrollAmount = () => {
      const item = slider.querySelector(".cs-collection__item");
      return item.offsetWidth + 30;
    };

    nextBtn.addEventListener("click", function () {
      track.scrollBy({ left: scrollAmount(), behavior: "smooth" });

      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 5) {
        setTimeout(() => {
          track.scrollTo({ left: 0, behavior: "smooth" });
        }, 400);
      }
    });

    prevBtn.addEventListener("click", function () {
      if (track.scrollLeft <= 5) {
        track.scrollTo({ left: track.scrollWidth, behavior: "smooth" });
      } else {
        track.scrollBy({ left: -scrollAmount(), behavior: "smooth" });
      }
    });

  });

});
